export default __webpack_public_path__ + "static/media/profit_wide.e16e49ca.jpg";